import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import DataActions from '../redux/dataRedux'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'

const id = 'EnergirMeasures'
const authId = 'Energir'
const datetimeId = 'Energir'

class MeasuresLayer extends Component {
  static contextTypes = {
    map: PropTypes.object
  }

  componentDidMount () {
    const { map } = this.context

    // map.on('mousemove', `energir-measures`, this.handleMouseMove)
    // map.on('mouseout', `energir-measures`, this.handleMouseOut)
  }

  componentWillUnmount () {
    const { map } = this.context

    // map.off('mousemove', `energir-measures`, this.handleMouseMove)
    // map.off('mouseout', `energir-measures`, this.handleMouseOut)
  }

  handleMouseOut = event => {
    const { map } = this.context
    const { actions } = this.props

    map.getCanvas().style.cursor = ''

    map.getCanvas().style.cursor = ''
    actions.dataUpdated({}, 'hover')
  }
  
  handleMouseMove = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props

    const features = map.queryRenderedFeatures(event.point, {
      layers: [`energir-measures`]
    })

    const data = features.map(feature => feature.properties)

    if (data) {      
      actions.dataUpdated(data[0], 'hover')
    }

    map.getCanvas().style.cursor = features.length > 0 ? 'pointer' : ''
  }

  render () {
    const { layerRendered } = this.props
    
    const before = 'default'

    if (!layerRendered) {
      return null
    }
    
    return (
      <div>
        <Source
          key={`energir-network`}
          id={`energir-network`}
          tileJsonSource={{
            type: 'vector',
            tiles: [`https://coresight-raster.s3-us-west-2.amazonaws.com/energir-network/{z}/{x}/{y}`],
            tileSize: 512,
            minzoom: 0,
            maxzoom: 11
          }}               
        />
        <Layer
          key={`energir-network-layer`}
          type='line'
          id={`energir-network`}
          sourceId={`energir-network`}
          sourceLayer={`energir-network`}
          layout={{
          }}
          paint={{
            'line-color': 'red',
            'line-width': {
              'base': 2,
              'stops': [[2, 2], [22, 180]]
            }
          }}
          before={before}
        />
        {/* <Source */}
        {/*   key={`energir--measures`} */}
        {/*   id={`energir-measures`} */}
        {/*   tileJsonSource={{ */}
        {/*     type: 'vector', */}
        {/*     tiles: [`https://coresight-raster.s3-us-west-2.amazonaws.com/energir-measures/{z}/{x}/{y}`], */}
        {/*     tileSize: 512, */}
        {/*     minzoom: 0, */}
        {/*     maxzoom: 11 */}
        {/*   }}                */}
        {/* /> */}
        {/* <Layer */}
        {/*   key={`energir-measures-layer`} */}
        {/*   type='circle' */}
        {/*   id={`energir-measures`} */}
        {/*   sourceId={`energir-measures`} */}
        {/*   sourceLayer={`energir-measures`}           */}
        {/*   layout={{ */}
        {/*   }} */}
        {/*   paint={{ */}
        {/*     'circle-color': 'black', */}
        {/*     'circle-opacity': 1, */}
        {/*     'circle-radius': { */}
        {/*       'base': 2, */}
        {/*       'stops': [[2, 1], [12, 4], [22, 180]] */}
        {/*     }, */}
        {/*   }} */}
        {/*   before={before} */}
        {/* /> */}
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()

  const mapStateToProps = (state) => {

    return {
      layerRendered: getLayerRendered(state, 'Energir', authId),
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      dataUpdated: (json, event) =>
        dispatch(DataActions.dataFulfilled(json, authId, event))
    }
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(MeasuresLayer)



// WEBPACK FOOTER //
// ./src/layers/EnergirMeasures.js